import axios from 'axios';

interface AuditResults {
  roi: string;
  timeSavings: number;
  recommendations: string[];
}

export const sendEmailAuditReport = async (toEmail: string, reportContent: AuditResults): Promise<boolean> => {
  const MAILGUN_API = 'https://api.eu.mailgun.net/v3/hypermesh-ai.com/messages';
  const apiKey = '7a45fb8bc2d23c5ff747aa468de499c4-24bda9c7-2964669c';
  
  // Create base64 encoded auth header that works in both Node.js and browser
  const authHeader = typeof Buffer !== 'undefined'
    ? 'Basic ' + Buffer.from('api:' + apiKey).toString('base64')
    : 'Basic ' + btoa('api:' + apiKey);

  const params = new URLSearchParams();
  params.append('from', 'HyperMesh AI <postmaster@hypermesh-ai.com>');
  params.append('to', toEmail);
  params.append('subject', 'Your AI Automation Audit Report');
  
  // Create HTML email content
  const htmlContent = `
    <html>
      <head>
        <style>
          body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
          .container { max-width: 600px; margin: 0 auto; padding: 20px; }
          .header { text-align: center; margin-bottom: 30px; }
          .metric { margin: 20px 0; }
          .metric-value { font-size: 24px; color: #00ff66; font-weight: bold; }
          .recommendations { margin: 30px 0; }
          .recommendation-item { 
            margin: 15px 0;
            padding: 15px;
            border-left: 4px solid #00fff2;
            background: #f8f9fa;
          }
          .cta-button {
            display: inline-block;
            padding: 12px 24px;
            background-color: #00ff66;
            color: #000;
            text-decoration: none;
            border-radius: 5px;
            font-weight: bold;
            margin-top: 20px;
          }
          .footer { margin-top: 40px; padding-top: 20px; border-top: 1px solid #eee; }
        </style>
      </head>
      <body>
        <div class="container">
          <div class="header">
            <h1>Your AI Automation Audit Report</h1>
          </div>
          
          <div class="metric">
            <h2>Projected ROI</h2>
            <div class="metric-value">${reportContent.roi}</div>
          </div>
          
          <div class="metric">
            <h2>Monthly Time Savings</h2>
            <div class="metric-value">${reportContent.timeSavings} hours</div>
          </div>
          
          <div class="recommendations">
            <h2>AI Recommendations</h2>
            ${reportContent.recommendations.map(rec => `
              <div class="recommendation-item">
                ${rec}
              </div>
            `).join('')}
          </div>
          
          <div class="footer">
            <p>Ready to implement these AI solutions?</p>
            <a href="https://calendly.com/hypermeshai/ai-consultation" class="cta-button">
              Book Your AI Strategy Call
            </a>
          </div>
        </div>
      </body>
    </html>
  `;

  params.append('html', htmlContent);

  try {
    const response = await axios.post(MAILGUN_API, params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': authHeader
      }
    });
    
    if (response.status === 200) {
      console.log('Email sent successfully:', response.data);
      return true;
    } else {
      console.error('Unexpected response status:', response.status, response.data);
      return false;
    }
  } catch (error) {
    console.error('Error sending email:', error.response?.data || error.message);
    return false;
  }
};